import React, { useState } from "react";
import { FcGoogle } from "react-icons/fc";
import { Link } from "react-router-dom";
import { default as logo_d, default as logo_w } from "../assets/svg/logo_w.svg";
import InputField from "../components/inputField/InputField";
import PasswordInput from "../components/inputField/PasswordInput";

function SignUp() {
  const [name, setName] = useState("");
  const [pass, setPass] = useState("");
  const [invite, setInvite] = useState("");

  const handleNameChange = (event) => {
    setName(event.target.value);
  };
  const handlepassChange = (event) => {
    setPass(event.target.value);
  };
  const handleInvChange = (event) => {
    setInvite(event.target.value);
  };

  return (
    <div className="logIn_page">
      <div className="log_container">
        <div className="lgoIn_left">
          <Link to="/" className="logo_area">
            <img src={logo_w} className="logo logo-white" alt="" />
            <img src={logo_d} className="logo logo-dark" alt="" />
            <h4>Casso Wealth</h4>
          </Link>
          <div>
            <p>
              "Someone is sitting in the shade today because someone planted a
              tree a long time ago. The same is true with credit; using it
              wisely can lead to future financial freedom."
            </p>
            <h4 className="name">Warren Buffett</h4>
          </div>
        </div>
        <div className="logIn_from">
          <div>
            <h1>Create an account</h1>
            <p className="mt-1">
              Enter your email below to create your account
            </p>
          </div>
          <form action="" className="input_group">
            <InputField
              label="Email"
              value={name}
              onChange={handleNameChange}
              placeholder="name@example.com"
            />
            <PasswordInput
              label="Password"
              value={pass}
              onChange={handlepassChange}
              placeholder="password"
            />
            <div className="mt-3">
              <InputField
                label="Invite Code"
                value={invite}
                onChange={handleInvChange}
                placeholder="Invite Code"
              />
            </div>
            <div className="btn_area">
              <Link to="/dashboard" className="mt-4">
                <button className="btn">Sign in with Email</button>
              </Link>
              <span className="mt-3 or_option">OR CONTINUE WITH</span>
              <button className="btn btn_s mt-3 google_btn">
                <FcGoogle />
                Sign in with Google
              </button>
              <p className="sign_up_area">
                Already have an Account. <Link to="/sign_in">Sign In</Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
export default SignUp;
